import { render, staticRenderFns } from "./NewModal.vue?vue&type=template&id=0282e6be&scoped=true"
import script from "./NewModal.vue?vue&type=script&lang=js"
export * from "./NewModal.vue?vue&type=script&lang=js"
import style0 from "./NewModal.vue?vue&type=style&index=0&id=0282e6be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0282e6be",
  null
  
)

export default component.exports